import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3097afc5832533a3d28d9d8c32d940f8b from "./generated-44b23713-4d6e-4328-b0fb-54444c566236.json";

import a302a939d18a9fe98230da49450945c2cb from "./generated-433b37fa-a015-40a5-b50c-91c549630d01.json";

import a4cd6b4595bdd85b0a544c5476edfe77bb from "./generated-6d87e651-3b40-4cc3-83b6-a48729e2f185.json";

import a667ed43f910028ffb0a3485e4a4de6cbb from "./generated-431ffc54-b25b-4efe-956f-c955e7ef3f60.json";

import a2f83154a6784c21ee2551fa66ea6469fb from "./generated-8a8edec2-59d8-4a9e-9b2b-7ed85d1fe458.json";

import a5f646dfca95b9970299306cecb5f7894b from "./generated-8cbbf590-5db6-4bdd-8d28-85ac974fa26e.json";

import a7f9797e205dfafa81eb76ea874ca6020b from "./generated-a13365ce-5011-4749-b7fd-b6178cd5f4be.json";

import a01be8c4558e73e5e34e826b5ee062311b from "./generated-b2370a2a-1e98-4f27-8c8f-5720a87d4723.json";

import a70ede7213abcd648082235ad8db7a910b from "./generated-01911750-9aa4-48e1-90ff-0b8b887a7a1c.json";

import a6909c571187f52bce20707dfa9cc4c29b from "./generated-25002a3e-57d5-46bb-866c-608ad4897e82.json";

import a0ddb142c4cfb708e8344e562c152b234b from "./generated-695ea937-6210-48f6-a2e9-c161f7c4d12a.json";

import ae48665c2ccbd4e3e2fbbc89afc746084b from "./generated-42c50049-cd7c-4044-ad92-145c9a054678.json";

import af27402b4eb0b36ebee79981700f29f7eb from "./generated-c54a451a-41c1-4fc8-bd45-ad5783e13985.json";

import a9dc74ceb3beaa99ee65198b051de0a37b from "./generated-226f51e6-2f99-4abf-a548-a60a37ba3024.json";

import a267dc5be0e4949e9608f92c4fdadc40fb from "./generated-6b68bc56-903c-4d34-a530-727ca78b85d6.json";

import a8e97ab0e44ce2fe77f8a79507981de76b from "./generated-6db611d8-9b8b-4102-b425-18e685c7bf02.json";

import a56579607db9993a85c1ec457a26185b5b from "./generated-9043bc3f-ec55-46d1-9427-ab464358c209.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3097afc5832533a3d28d9d8c32d940f8b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a302a939d18a9fe98230da49450945c2cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a4cd6b4595bdd85b0a544c5476edfe77bb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a667ed43f910028ffb0a3485e4a4de6cbb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a2f83154a6784c21ee2551fa66ea6469fb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5f646dfca95b9970299306cecb5f7894b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7f9797e205dfafa81eb76ea874ca6020b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a01be8c4558e73e5e34e826b5ee062311b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a70ede7213abcd648082235ad8db7a910b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a6909c571187f52bce20707dfa9cc4c29b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a0ddb142c4cfb708e8344e562c152b234b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae48665c2ccbd4e3e2fbbc89afc746084b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a70ede7213abcd648082235ad8db7a910b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(af27402b4eb0b36ebee79981700f29f7eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a9dc74ceb3beaa99ee65198b051de0a37b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a70ede7213abcd648082235ad8db7a910b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a267dc5be0e4949e9608f92c4fdadc40fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a8e97ab0e44ce2fe77f8a79507981de76b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a56579607db9993a85c1ec457a26185b5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a267dc5be0e4949e9608f92c4fdadc40fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */